import React, { Component } from "react";
import { connect } from "react-redux";
import LocaleStrings from "Languages";
import { sortableHandle } from "react-sortable-hoc";
import _ from "lodash";
import { BASE_IMAGES_URL } from "Constants";
import LocationMapItem from "./location-map-item";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const DragHandle = sortableHandle(
  ({ imageurl, dataobject, apiKey, sessionToken }) => (
    <div className=" DraggedStuff">
      <div className="vcenter">
        <i className="fa fa-bars mx-6" aria-hidden="true"></i>
        <img
          style={{
            height: 35,
            width: 40,
            borderRadius: "10%",
            paddingRight: 6,
          }}
          src={
            imageurl === "" || imageurl === null
              ? "../../style/images/no-map-image.png"
              : `${BASE_IMAGES_URL}/${imageurl}?api_key=${apiKey}&session_token=${sessionToken}`
          }
        />
        <b>
          {_.has(dataobject, "interactivemapid")
            ? dataobject.mapname.length > 35
              ? dataobject.mapname.substring(0, 35) + "..."
              : dataobject.mapname
            : _.has(dataobject, "mapid")
            ? dataobject.name.length > 35
              ? dataobject.name.substring(0, 35) + "..."
              : dataobject.name
            : ""}
        </b>
      </div>
    </div>
  )
);

class AllMapItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  render() {
    let { mapdata } = this.props;
    return (
      <div
        // className="row"
        style={{
          fontWeight: "normal",
          color: "rgb(63,68,88)",
          borderTop: "1px solid #e6edf3",
          // padding: "10px 0",
          cursor: "move",
        }}
      >
        <Container fluid>
          <Row>
            <Col style={{ marginLeft: "50px" }}>
              {" "}
              <DragHandle
                imageurl={
                  _.has(mapdata, "interactivemapid")
                    ? mapdata.mapfilepath
                    : _.has(mapdata, "mapid")
                    ? mapdata.thumbimagepath
                    : ""
                }
                dataobject={mapdata}
                apiKey={this.props.session.apiKey}
                sessionToken={this.props.session.sessionToken}
              />
            </Col>
            <Col style={{ paddingTop: "14px" }}>
              {" "}
              <span className="vcenter">
                {_.has(mapdata, "interactivemapid")
                  ? LocaleStrings.content_map_interactive
                  : LocaleStrings.content_map_location}{" "}
              </span>
            </Col>
            <Col>
              {" "}
              {_.has(mapdata, "interactivemapid") ? (
                <LocationMapItem locationmap={mapdata} is_locationmap={false} />
              ) : (
                <LocationMapItem locationmap={mapdata} is_locationmap={true} />
              )}{" "}
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export var mapStateToProps = (state) => {
  var { session } = state;

  return {
    session: state.session,
  };
};
export default connect(mapStateToProps, {})(AllMapItem);
